import { render, staticRenderFns } from "./UpdateBagNo.vue?vue&type=template&id=177c74cb&"
import script from "./UpdateBagNo.vue?vue&type=script&lang=js&"
export * from "./UpdateBagNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports